// Archive-noir palette (v3). Mirror of the CSS custom properties in App.css.
// Use these tokens in inline-styles only; prefer CSS variables for global styles.
export const C = {
  // Backgrounds
  ink:        "#0B0F10",
  archive:    "#12171A",
  leather:    "#1A2025",
  // Borders
  dust:       "#2A3238",
  haze:       "#3D4850",
  // Accents
  cinnabar:   "#DC4A3D",
  oxide:      "#7A2E1F",
  brass:      "#B8A478",
  verdigris:  "#5B7A6F",
  // Text hierarchy
  bone:       "#D4CDB8",
  linen:      "#9AA39C",
  steel:      "#7D8F9A",
  smoke:      "#5C6670",
  whisper:    "#2F363C",
};
